import { Box, HStack, Portal } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { usePageContainerBottomRef } from "shared/components/layout/PageContainer";
import { shadows } from "theme/shadows";

const footerHeight = "64px";

export const FormFooter: React.FC<React.PropsWithChildren> = ({ children }) => {
  const containerRef = usePageContainerBottomRef();

  useEffect(() => {
    // FIXME: Might be possible to portal toasts into the bottom
    //  container (above the box added below) once this is fixed:
    //  https://github.com/chakra-ui/chakra-ui/issues/6370
    const toastManager = document.getElementById(
      "chakra-toast-manager-bottom-right",
    );
    if (toastManager) {
      toastManager.style.marginBottom = footerHeight;
    }
    return () => {
      if (toastManager) {
        toastManager.style.marginBottom = "0px";
      }
    };
  }, []);

  return (
    <>
      <Portal containerRef={containerRef}>
        {/* The footer itself can't go in the portal because this breaks form submit buttons */}
        <Box height={footerHeight} />
      </Portal>
      <HStack
        px="24px"
        flex={1}
        bg="white"
        boxShadow={shadows.bottomBar}
        position="fixed"
        justifyContent="space-between"
        insetX={0}
        bottom={0}
        zIndex={30}
        flexWrap="wrap"
      >
        {children}
      </HStack>
    </>
  );
};

export const FormFooterActions: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <HStack spacing={0} gap="8px" py="12px" flex={1} justifyContent="flex-end">
    {children}
  </HStack>
);

export const FormFooterBreadcrumb: React.FC<React.PropsWithChildren> = ({
  children,
}) => <Box py="24px">{children}</Box>;
